import { Type } from "@sinclair/typebox";
import { IdSchema, JsonValueSchema, Sha256Schema, TimestampSchema } from "./shared.js";
import { BudgetSchema } from "./action.js";
import { PresentationContractSchema } from "./presentation.js";
import { FileIoContractSchema } from "./files.js";
import { LifecycleContractSchema } from "./lifecycle.js";
export const RuntimeExecutionLeaseSchema = Type.Object({
    scopeKind: Type.Union([
        Type.Literal("tool"),
        Type.Literal("runtime-instance"),
        Type.Literal("runtime-worker"),
        Type.Literal("runtime-io"),
        Type.Literal("runtime-lifecycle"),
    ]),
    resources: Type.Object({
        cpuCount: Type.Integer({ minimum: 1, maximum: 256 }),
        memoryBytes: Type.Integer({ minimum: 1, maximum: 1024 ** 4 }),
        pidLimit: Type.Integer({ minimum: 1, maximum: 1048576 }),
    }, { additionalProperties: false }),
    baseSessionMemoryBytes: Type.Integer({ minimum: 1, maximum: 1024 ** 4 }),
    ownerDigest: Sha256Schema,
    sessionDigest: Sha256Schema,
    grantDigest: Sha256Schema,
    invocationId: Type.String({ pattern: "^[0-9a-f]{32}$" }),
    admissionId: Type.Union([Type.String({ pattern: "^[0-9a-f]{32}$" }), Type.Null()]),
    commandDigest: Sha256Schema,
    environmentDigest: Sha256Schema,
    environmentNames: Type.Array(Type.String({ pattern: "^[A-Za-z_][A-Za-z0-9_]{0,127}$" }), {
        maxItems: 128,
        uniqueItems: true,
    }),
    deadlineUnixMs: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
    state: Type.Union([
        Type.Literal("pending"),
        Type.Literal("admitted"),
        Type.Literal("terminal"),
    ]),
}, { additionalProperties: false });
export const RuntimeExecutionAdmissionSchema = Type.Object({
    admissionId: Type.String({ pattern: "^[0-9a-f]{32}$" }),
    ownerDigest: Sha256Schema,
    sessionDigest: Sha256Schema,
    requestDigest: Sha256Schema,
    scopeKind: RuntimeExecutionLeaseSchema.properties.scopeKind,
    deadlineUnixMs: RuntimeExecutionLeaseSchema.properties.deadlineUnixMs,
    state: Type.Union([
        Type.Literal("pending"),
        Type.Literal("authorized"),
        Type.Literal("terminal"),
    ]),
}, { additionalProperties: false });
export const FunctionContractSchema = Type.Object({
    serverId: IdSchema,
    lifecycle: LifecycleContractSchema,
    functionName: Type.String({ minLength: 1, maxLength: 256 }),
    inputSchema: JsonValueSchema,
    fileIo: Type.Optional(FileIoContractSchema),
    outputSchema: JsonValueSchema,
    presentationContract: Type.Optional(PresentationContractSchema),
    schemaDigest: Sha256Schema,
    effect: Type.Union([
        Type.Literal("read_only"),
        Type.Literal("compute"),
        Type.Literal("external_side_effect"),
        Type.Literal("destructive"),
    ]),
    maximumBudget: BudgetSchema,
    maximumWallTimeMs: Type.Integer({ minimum: 1_000, maximum: 7 * 24 * 60 * 60_000 }),
}, { additionalProperties: false });
/** 工具主动报告的公开快照；缺失字段不能由平台估算或从日志猜测。 */
export const ToolJobProgressSchema = Type.Object({
    job_id: Type.String({ minLength: 1, maxLength: 256 }),
    status: Type.Union([
        Type.Literal("pending"),
        Type.Literal("queued"),
        Type.Literal("running"),
        Type.Literal("succeeded"),
        Type.Literal("failed"),
        Type.Literal("cancelled"),
    ]),
    observed_at: TimestampSchema,
    queue: Type.Optional(Type.Object({
        position: Type.Optional(Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })),
        jobs_ahead: Type.Optional(Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })),
        running_jobs: Type.Optional(Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })),
        total_queued: Type.Optional(Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })),
    }, { additionalProperties: false })),
}, { additionalProperties: false });
//# sourceMappingURL=tools.js.map